export const PERMISSION_LEVELS = [
  {
    value: 'edit',
    label: 'Can edit',
    description: 'View and edit this plan.',
  },
  {
    value: 'freeze',
    label: 'Can edit & freeze',
    description:
      'Can also freeze and unfreeze the plan. While frozen, no one can edit it.',
  },
] as const

export function getPermissionLabel(canFreeze: boolean) {
  return PERMISSION_LEVELS[canFreeze ? 1 : 0].label
}
